import { FC } from "react";

export const TermsAndConditions: FC = () => (
  <div className="waybill-page terms-page">
    <div className="waybill-grid">
      <div className="terms-content">
        <h3>Terms & Conditions</h3>
        <div className="terms-text">
          <div className="terms-section">
            <strong>1. ACCEPTANCE & LIABILITY</strong> Acceptance of goods
            constitutes agreement to these terms. Our liability is limited to
            .50 cents per pound per article unless declared value and additional
            charges are paid.
          </div>
          <div className="terms-section">
            <strong>2. ADDITIONAL INSURANCE</strong> Client may request
            additional coverage. We recommend clients secure fine arts coverage
            for high-value items. Must be confirmed in writing with premium paid
            in advance.
          </div>
          <div className="terms-section">
            <strong>3. CLAIMS</strong> All damage/loss claims must be reported
            within 1 business days of delivery. Claims must be submitted in
            writing within 7 days with supporting documentation.
          </div>
          <div className="terms-section">
            <strong>4. PAYMENT</strong> Payment due within 30 days of invoice
            date, or before delivery, whichever first. Unpaid accounts subject
            to 1.5% monthly service charge and collection costs.
          </div>
          <div className="terms-section">
            <strong>5. STORAGE</strong> Storage charges apply after 5 business
            days. Items held over 30 days without payment are subject to liens.
          </div>
          <div className="terms-section">
            <strong>6. HANDLING</strong> We exercise reasonable care but are not
            liable for damage due to inherent vice, improper packaging,
            pre-existing condition, or normal wear.
          </div>
          <div className="terms-section">
            <strong>7. FORCE MAJEURE</strong> Not liable for delays/damages due
            to acts of God, weather, strikes, government actions, or
            circumstances beyond our control.
          </div>
          <div className="terms-section">
            <strong>8. JURISDICTION</strong> All disputes governed by NYS law.
            Any legal action must be filed within 6 months of incident.
          </div>
          <div className="terms-footer">
            By signing above, shipper and consignee agree to these terms and
            conditions.
          </div>
        </div>
      </div>
    </div>
  </div>
);
